enum WeblabId {
  SELLER_FORUMS_PROFILE_ACTIVITY = 'SELLER_FORUMS_PROFILE_ACTIVITY_697648',
  SELLER_FORUMS_MIDDLEWARE_VALIDATIONS = 'SELLER_FORUMS_MIDDLEWARE_VALIDATION_874508',
  SELLER_FORUMS_NOTIFICATIONS_SSR = 'SELLER_FORUMS_NOTIFICATIONS_SSR_880631',
  SELLER_FORUMS_THREAD_DETAILS_SSR = 'SELLER_FORUMS_THREAD_DETAIL_SSR_904513',
  SELLER_FORUMS_THREAD_LISTING_SSR = 'SELLER_FORUMS_THREAD_LISTING_SSR_909554',
  SELLER_FORUMS_THREAD_DETAIL_SSR_SESSION = 'SELLER_FORUMS_THREAD_DETAIL_SSR_SESSION_922232',
  SELLER_FORUMS_HOMEPAGE_SSR = 'SELLER_FORUMS_HOMEPAGE_SSR_902971',
  SELLER_FORUMS_NAVBAR_ADAPTIVE = 'SELLER_FORUMS_NAVBAR_ADAPTIVE_888930',
  SELLER_FORUMS_VIEWPORT_WIDTH_REMOVAL = 'SELLER_FORUMS_VIEWPORT_WIDTH_REMOVAL',
  SELLER_FORUMS_USER_PREF_STORAGE = 'SELLER_FORUMS_USER_PREF_STORAGE_886934',
  SELLER_FORUMS_NOTIFICATIONS_ADAPTIVE = 'SELLER_FORUMS_NOTIFICATIONS_ADAPTIVE_901043',
  SELLER_FORUMS_SILENCED_USER_UPDATE_PROFILE_IMAGE = 'SELLER_FORUMS_SILENCED_USER_UPDATE_PROFILE_IMAGE_894108',
}

export const getPrimaryWeblabConfig = () => [
  {
    weblabIds: [WeblabId.SELLER_FORUMS_THREAD_DETAIL_SSR_SESSION],
    primaryWeblabId: WeblabId.SELLER_FORUMS_THREAD_DETAILS_SSR,
  },
];

export default WeblabId;
